import React, { useEffect, useRef, useState } from "react";
import { Stack } from "react-bootstrap";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import "./CreateUserNamePage.scss";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import { CustomSpinner } from "../../../components/CustomSpinner/CustomSpinner";
import AvatarSection from "../../../components/create-username-page/AvatarSection/AvatarSection";
import { userProfileAtom } from "../../../jotai/atoms/user";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import OnboardingHeader from "../../../components/Headers/OnboardingHeader/OnboardingHeader";
import { GOAL_ONBOARDING_STEPS } from "../../../utils/constants";
import UsernameInput, {
  UsernameUpdateOrigin,
} from "../../../components/create-username-page/UsernameInput/UsernameInput";

function CreateUserNamePage() {
  const { t } = useTranslation("common", { keyPrefix: "onboarding" });
  const [isLoading, setIsLoading] = useState(false);
  const userProfile = useAtomValue(userProfileAtom);
  const [username, setUsername] = useState(userProfile?.username ?? "");
  const usernameHasBeenEdited = useRef(false);

  useEffect(() => {
    if (usernameHasBeenEdited.current) return;
    setUsername(userProfile?.username ?? "");
  }, [userProfile?.id, userProfile?.username]);

  const handleUsernameChange: React.Dispatch<
    React.SetStateAction<string>
  > = (value) => {
    usernameHasBeenEdited.current = true;
    setUsername(value);
  };

  return (
    <OnboardingContainer className="d-flex flex-column create-username-page justify-content-between">
      <OnboardingHeader
        amountActive={3}
        steps={GOAL_ONBOARDING_STEPS}
        showBackButton={false}
      />
      <Stack
        gap={3}
        className="justify-content-center align-items-center create-username-content"
      >
        <AvatarSection />
        <UsernameInput
          username={username}
          setUsername={handleUsernameChange}
          setIsLoading={setIsLoading}
          focusInputOnMount={true}
          origin={UsernameUpdateOrigin.ONBOARDING}
        />
      </Stack>
      <PrimaryActionButton
        type="submit"
        form="username-form"
        size="lg"
        text={
          <>
            {isLoading && <CustomSpinner size="sm" />}
            {t("claim_username")}
          </>
        }
        disabled={isLoading || !username}
      />
    </OnboardingContainer>
  );
}

export default CreateUserNamePage;
